import { render, staticRenderFns } from "./SalaryExpectation.vue?vue&type=template&id=23b51a78&scoped=true&"
import script from "./SalaryExpectation.vue?vue&type=script&lang=ts&"
export * from "./SalaryExpectation.vue?vue&type=script&lang=ts&"
import style0 from "./SalaryExpectation.vue?vue&type=style&index=0&id=23b51a78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b51a78",
  null
  
)

export default component.exports